function paramInURL(parametroName) {
  const parametrosURL = new URLSearchParams(window.location.search);
  return parametrosURL.has(parametroName);
}

/** *******************************************************
Gets the value of a cookie.
********************************************************* */
export function getCookie(chName) {
  const checker = document.cookie.split(';');
  for (let i = 0; i < checker.length; i++) {
    const chMach = checker[i].split('=');
    const chKey = decodeURIComponent(chMach[0].trim());
    const chValue = chMach.length > 1 ? chMach[1] : '';
    if (chKey == chName) {
      return decodeURIComponent(chValue);
    }
  }
  return '';
}
/** ***************************************************************
Sets the value of a cookie. Expiration date and path are optional.
***************************************************************** */
export function setCookie(chName, chValue, options) {
  // oDate.setYear(oDate.getFullYear()+1);
  let chCookie = `${encodeURIComponent(chName)}=${encodeURIComponent(chValue)}`;

  // Shorthand: options === expires date
  if (options && options instanceof Date) {
    options = {
      expires: options,
    };
  }
  // Longhand: options object
  if (options && typeof options === 'object') {
    if (options.expires) {
      chCookie += `; expires=${options.expires.toGMTString()}`;
    }
    if (options.path) {
      chCookie += `; path=${options.path.toString()}`;
    } else {
      chCookie += '; path=/';
    }
    if (options.domain) {
      chCookie += `; domain=${options.domain.toString()}`;
    }
    if (options.secure) {
      chCookie += '; secure';
    }
  }
  document.cookie = chCookie;
}
/** *******************************************************
Clears and immediately expires a cookie.
********************************************************* */
export function removeCookie(sName, options) {
  if (!options) {
    var options = {};
  }
  options.expires = new Date();
  setCookie(sName, '', options);
}

// Función para añadir los parámetros de las cookies a la URL
export function addParamsFromCookies() {
  const urlParams = new URLSearchParams(window.location.search);

  const rid = getCookie('rid');
  const pid = getCookie('pid');

  const ridInUrl = urlParams.get('rid');
  const pidInUrl = urlParams.get('pid');

  if (rid !== '' || pid !== '') {
    if (rid !== '' && !ridInUrl) {
      urlParams.set('rid', rid);
    }
    if (pid !== '' && !pidInUrl) {
      urlParams.set('pid', pid);
    }

    // Reemplazar la URL sin recargar la página si se han añadido parámetros
    if ((rid !== '' && !ridInUrl) || (pid !== '' && !pidInUrl)) {
      window.history.replaceState(null, '', `?${urlParams.toString()}`);
    }
  }
}
/** *******************************************************
Check for new URL and set cookies
********************************************************* */
export function saveUrlParamsIntoCookie() {
  // Obtener la URL actual
  const url = window.location.href;
  const now = new Date();
  const time = now.getTime();
  const expireTime = time + 1000 * 36000;
  now.setTime(expireTime);
  // Verificar si la URL tiene parámetros
  if (url.indexOf('?') !== -1) {
    // Obtener los parámetros de la URL
    const parametros = url.split('?')[1].split('&');

    // Recorrer los parámetros y guardarlos en cookies
    for (let i = 0; i < parametros.length; i++) {
      const parametro = parametros[i].split('=');
      const nombre = decodeURIComponent(parametro[0]);
      const valor = decodeURIComponent(parametro[1]);
      setCookie(nombre, valor, now);
      // Guardar el parámetro en una cookie
      // document.cookie = `${nombre}=${valor}; path=/`;
    }
  }
}

export function addCookieAsUrlParam(cookieName) {
  if (!paramInURL(cookieName)) {
    // Obtener el valor de la cookie
    const cookieValue = getCookie(cookieName);

    // Obtener la URL actual
    let url = window.location.href;

    // Verificar si ya hay una cadena de consulta en la URL
    if (url.indexOf('?') !== -1) {
      // La URL ya tiene una cadena de consulta, agregar el nuevo parámetro
      url += `&${cookieName}=${encodeURIComponent(cookieValue)}`;
    } else {
      // La URL no tiene una cadena de consulta, agregar el nuevo parámetro
      url += `?${cookieName}=${encodeURIComponent(cookieValue)}`;
    }

    // Redireccionar a la URL modificada
    window.location.href = url;
  }
}
